import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutHandlingRequirementsList extends Layout {
    layoutheaderHDRList: LayoutHeader;
    sourceHandlingRequirement: DataSource;
    tableHandlingRequirements: Table;
}
